export default class Carousel {
  constructor(el, startSlide) {
    this.id = el.getAttribute('data-slider');
    this.slider = document.querySelector(`[data-slider="${this.id}"]`);
    this.navigation = this.slider.querySelector(`[data-navigation="${this.id}"]`);
    this.prevBtn = this.navigation.querySelector('.arrow-wrapper--prev');
    this.nextBtn = this.navigation.querySelector('.arrow-wrapper--next');
    this.slideLists = this.slider.querySelectorAll(`[data-slide-list="${this.id}"]`);
    this.lastSlide = this.slideLists[0].children.length - 1; // TODO: parametrize
    this.deltaSpace = 100 / (this.lastSlide + 1);
    this.currentSlide = startSlide || 0;
  }

  init() {
    const isFirstSlide = this.currentSlide === 0;
    const isLastSlide = this.currentSlide === this.lastSlide;
    if (isFirstSlide) this.prevBtn.classList.add('disabled');
    if (isLastSlide) this.nextBtn.classList.add('disabled');

    this.slideLists.forEach((list) => { // for each slider
      const children = list.children; // slides themselves
      [].forEach.call(children, (child, index) => { // for each slide
        if (index === this.currentSlide) {
          children[this.currentSlide].setAttribute('data-slide', 'true');
          children[this.currentSlide].style.transform = 'translateX(0)';
        } else {
          const direction = index > this.currentSlide ? 1 : -1;
          children[index].setAttribute('data-slide', 'false');
          children[index].style.transform = `translateX(${direction * 100}%)`;
        }
      });
    });

    this.prevBtn.addEventListener('click', this.prevSlide.bind(this));
    this.nextBtn.addEventListener('click', this.nextSlide.bind(this));
  }

  prevSlide() {
    const isFirstSlide = this.currentSlide === 0;

    if (!isFirstSlide) {
      const previousSlide = this.currentSlide;
      if (this.currentSlide === this.lastSlide) this.nextBtn.classList.remove('disabled');
      if (this.currentSlide === 1) this.prevBtn.classList.add('disabled');
      this.currentSlide -= 1;
      this.activateSlide(previousSlide);
    }
  }

  nextSlide() {
    const isLastSlide = this.currentSlide === this.lastSlide;

    if (!isLastSlide) {
      const previousSlide = this.currentSlide;
      if (this.currentSlide === 0) this.prevBtn.classList.remove('disabled');
      if (this.currentSlide === (this.lastSlide - 1)) this.nextBtn.classList.add('disabled');
      this.currentSlide += 1;
      this.activateSlide(previousSlide);
    }
  }

  activateSlide(previousSlide) {
    this.slideLists.forEach((list) => {
      const direction = this.currentSlide > previousSlide ? -1 : 1;
      const children = list.children;
      children[previousSlide].setAttribute('data-slide', 'false');
      children[this.currentSlide].setAttribute('data-slide', 'true');
      children[previousSlide].style.transform = `translateX(${direction * 100}%)`;
      children[this.currentSlide].style.transform = 'translateX(0)';
    });
  }
}



// WEBPACK FOOTER //
// local_static/templates/volei/2018/assets/scripts/modules/Carousel.js